jQuery(document).ready(function ($) {

	$(".js-select:not([name=\"time\"])").find("option:selected").prop("disabled", true);

	$(".js-select").select2({
		minimumResultsForSearch: Infinity,
		width: "100%",
		theme: "pwc",
	});


	$(".js-select--placeholder").each(function () {
		const $select = $(this),
			placeholderText = $select.find("option:first").text();

		$select.select2({
			minimumResultsForSearch: Infinity,
			width: "100%",
			theme: "pwc",
			placeholder: placeholderText,
			closeOnSelect: !$select.prop("multiple"),
		});

		$select.find("option:first").attr("disabled", true).attr("value", "");
	});

	$(".js-select-dark").select2({
		minimumResultsForSearch: Infinity,
		width: "100%",
		theme: "pwc-dark",
	});

	$(".js-redirect").on("change", function () {
		window.location = this.value;
	});


});
